class ReviewStars {
    constructor(containerId = 'reviewStarsContainer') {
        this.containerId = containerId;
        this.averageRating = 0;
        this.totalReviews = 0;
        this.starsDistribution = [];
        this.isLoading = false;
        this.handle = null;
        this.apiUrl = null;
        this.init();
    }
    
    init() {
        const container = document.getElementById(this.containerId);
        if (container) {
            this.handle = document.location.pathname.split('/').filter(part => part !== '').pop();
            this.apiUrl = "https://api.ultimate.thetabrands.com/reviews/stats";
        }
        this.fetchReviewSummary();
    }

    async fetchReviewSummary() {
        this.isLoading = true;
        this.updateLoadingState();

        try {
            let url = `${this.apiUrl}?filter=recent&limit=1&page=1`;
            if (this.handle) {
                url += `&handle=${encodeURIComponent(this.handle)}`;
            }
            const response = await fetch(url);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            
            // Handle new stats format
            if (data.stats) {
                this.totalReviews = data.stats.totalReviews || 0;
                this.averageRating = parseFloat(data.stats.averageRating) || 0;
                this.starsDistribution = data.stats.starsDistribution || [];
            } else {
                // Fallback to old format for backward compatibility
                this.totalReviews = data.totalCount || data.total || data.count || (data.reviews ? data.reviews.length : 0);
                this.averageRating = data.averageRating || data.average || data.rating || 0;
            }

            this.render();
        } catch (error) {
            console.error('Error fetching review summary:', error);
            this.showError('Failed to load review summary.');
        } finally {
            this.isLoading = false;
            this.updateLoadingState();
        }
    }

    updateLoadingState() {
        const container = document.getElementById(this.containerId);
        if (!container) return;

        const loadingEl = container.querySelector('.loadingIndicator');

        if (this.isLoading) {
            if (!loadingEl) {
                const loading = document.createElement('div');
                loading.className = 'loadingIndicator';
                loading.textContent = 'Loading review summary...';
                container.appendChild(loading);
            }
        } else {
            if (loadingEl) {
                loadingEl.remove();
            }
        }
    }

    showError(message) {
        const container = document.getElementById(this.containerId);
        if (!container) return;

        const errorEl = container.querySelector('.errorMessage');
        if (errorEl) {
            errorEl.remove();
        }

        const error = document.createElement('div');
        error.className = 'errorMessage';
        error.textContent = message;
        container.appendChild(error);

        setTimeout(() => {
            if (error.parentNode) {
                error.remove();
            }
        }, 5000);
    }

    renderStars(rating, size = "medium") {
        const container = document.createElement('div');
        container.className = 'starContainer';
        container.style.display = 'inline-flex';
        container.style.alignItems = 'center';

        const clampedRating = Math.max(0, Math.min(5, rating));
        const starSize = size === "small" ? 16 : size === "large" ? 24 : 20;

        const starPath = "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z";

        for (let i = 1; i <= 5; i++) {
            let fillPercentage = 0;

            if (i <= clampedRating) {
                fillPercentage = 100;
            } else if (i - 1 < clampedRating) {
                fillPercentage = (clampedRating - (i - 1)) * 100;
            }

            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('width', starSize);
            svg.setAttribute('height', starSize);
            svg.setAttribute('viewBox', '0 0 24 24');
            svg.classList.add('star-svg');
            svg.setAttribute('title', `${clampedRating} stars`);
            svg.style.marginRight = '2px';

            // Background star (unfilled)
            const bgPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            bgPath.setAttribute('d', starPath);
            bgPath.setAttribute('fill', '#e1e1e1');
            bgPath.setAttribute('stroke', '#e1e1e1');
            bgPath.setAttribute('stroke-width', '0.5');
            svg.appendChild(bgPath);

            // Filled portion
            if (fillPercentage > 0) {
                const fgPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
                fgPath.setAttribute('d', starPath);
                fgPath.setAttribute('fill', '#fabf46');
                fgPath.setAttribute('stroke', '#fabf46');
                fgPath.setAttribute('stroke-width', '0.5');

                if (fillPercentage < 100) {
                    fgPath.style.clipPath = `inset(0 ${100 - fillPercentage}% 0 0)`;
                }

                svg.appendChild(fgPath);
            }

            container.appendChild(svg);
        }

        return container;
    }

    render() {
        const container = document.getElementById(this.containerId);
        if (!container) return;

        // Clear existing content
        container.innerHTML = '';
        
        // Don't render if no reviews
        if (this.totalReviews === 0 && this.averageRating === 0) {
            const noReviewsDiv = document.createElement('div');
            noReviewsDiv.className = 'noReviews';
            noReviewsDiv.textContent = 'No reviews yet.';
            container.appendChild(noReviewsDiv);
            return;
        }

        container.classList.remove('hidden');

        const link = document.createElement('a');
        link.href = '#reviewBoxesContainer';
        link.className = 'reviewStarsLink';

        const starsDiv = document.createElement('div');
        starsDiv.className = 'reviewStars';

        const starsContainer = this.renderStars(this.averageRating);
        starsDiv.appendChild(starsContainer);

        const ratingText = document.createElement('span');
        ratingText.textContent = `${this.averageRating.toFixed(1)} (${this.totalReviews} Reviews)`;
        starsDiv.appendChild(ratingText);

        link.appendChild(starsDiv);
        container.appendChild(link);
    }

    // Public method to refresh the component
    refresh() {
        this.fetchReviewSummary();
    }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    window.reviewStars = new ReviewStars();
});

// Export for use in other contexts
if (typeof module !== 'undefined' && module.exports) {
    module.exports = ReviewStars;
}